export default {
  sortArrayByOrder(arr, ord, getFieldCallback) {
    if (typeof getFieldCallback != "function") {
      getFieldCallback =  v => v;
    }
    const orderIndex = item => ord.indexOf(getFieldCallback(item));
    const indexOrMax = i => i >= 0 ? i : ord.length + 1;
    const resultIndex = item => indexOrMax(orderIndex(item));
    arr.sort( (a, b) => resultIndex(a) - resultIndex(b));
  },

  splitArrayToSubarrays(array, size) {
    let subarray = [];
    for (let i = 0; i < Math.ceil(array.length/size); i++){
        subarray[i] = array.slice((i*size), (i*size) + size);
    }
    return subarray;
  },

  equal(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a == undefined || b == undefined) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  },

  getUnique(array) {
    return array.filter((v, i, list) => list.indexOf(v) === i)
  },

  toNumbers(array) {
    return array.filter( it => !isNaN(+it) ).map( it => +it );
  },

  difference(from, array) {
    return from.filter( it => array.indexOf(it) === -1 )
  },
};
